export class CompanyAggregatePosition {
  companyId: number;
  shares: number;
  nonStockShares: number;
  costBasis: number;
  discount: number;
  manualPrice: number;
  fundValues: Record<number, Array<{portfolioName: string, portfolioValue: number, stockType: string, fullyBoxed?: boolean}>>;
  totalPL: number;

  constructor(data?: Partial<CompanyAggregatePosition>) {
    this.companyId = data.companyId || null;
    this.shares = data.shares || null;
    this.nonStockShares = data.nonStockShares || null;
    this.costBasis = data.costBasis || null;
    this.discount = data.discount || null;
    this.manualPrice = data.manualPrice || null;
    this.fundValues = data.fundValues || null;
    this.totalPL = data.totalPL || null;
  }
}
